import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { ListItem } from '../../widgets/models/list-item';
import { GetExecutionPathAction } from '../store/actions/pathway-selections.actions';
import { selectPathwaysListState } from '../store/selectors/pathway-selections.selector';
import { takeUntil } from 'rxjs/operators';
import { PlaceholderChildComponent } from '@ispm/layout/classes/placeholder-child-component.abstract';
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import {IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";
import {Widget} from "@ispm/widgets/decorator/widget.decorator";

@Component({
  selector:    'ispm-pathways-list',
  templateUrl: './pathways-list.component.html',
  styleUrls:   ['./pathways-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget()
export class PathwaysListComponent extends PlaceholderChildComponent  implements  OnInit, OnDestroy ,IWidgetItem {
  public items$: Observable<ListItem[]>;
  private destroyed$: Subject<any> = new Subject();
  private config:any;
  public widgetData:any;

  constructor(private store$: Store<any>) {
    super();
  }

  ngOnInit() {
    this.items$ = this.store$.pipe(
      select(selectPathwaysListState),
      takeUntil(this.destroyed$.asObservable())
    );

    this.store$.dispatch(new GetExecutionPathAction({ }));
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  beforeClose() {
  }

  set widgetConfig(widgetConfig: IdynamicFormItem<any>) {
    this.config = widgetConfig;
  }

}
